import { GroupsActionType, GROUP_PROP } from './constants'

export const initialCreateState = {
    [GROUP_PROP.NAME]: '',
    [GROUP_PROP.PERMISSIONS]: [],
    [GROUP_PROP.USERS]: [],
}

export const getDefaultState = () => ({
    editGroupDialog: initialCreateState,
    createGroupDialog: initialCreateState,
    table: {
        orderBy: {
            col: GROUP_PROP.NAME,
            order: 'asc',
        },
        search: '',
        limit: 10,
        offset: 0,
        filters: [],
    },
    isEditDialogOpen: false,
    isCreateDialogOpen: false,
    isConfirmationDialogOpen: false,
    groups: [],
    total: 0,
    existingPermissions: [],
    existingUsers: [],
})

export default (state = getDefaultState(), action) => {
    switch (action.type) {
        case GroupsActionType.SET_GROUPS:
            return setGroupsData(state, action)

        case GroupsActionType.SET_EXISTING_PERMISSIONS:
            return setExistingPermissions(state, action)
        case GroupsActionType.SET_EXISTING_USERS:
            return setExistingUsers(state, action)

        case GroupsActionType.SET_CREATE_GROUP:
            return setCreateGroupDialog(state, action)
        case GroupsActionType.OPEN_CREATE_DIALOG:
            return openCreateDialog(state, action)
        case GroupsActionType.CLOSE_CREATE_DIALOG:
            return closeCreateDialog(state, action)

        case GroupsActionType.SET_EDIT_GROUP:
            return setEditGroup(state, action)
        case GroupsActionType.OPEN_EDIT_DIALOG:
            return openEditDialog(state, action)
        case GroupsActionType.CLOSE_EDIT_DIALOG:
            return closeEditDialog(state, action)

        case GroupsActionType.SET_ORDER_BY:
            return setOrderBy(state, action)
        case GroupsActionType.SET_PAGING_OPT:
            return setPagingOptions(state, action)
        case GroupsActionType.SET_PAGE_OFFSET:
            return setPageOffset(state, action)
        case GroupsActionType.SET_FILTER:
            return setFilter(state, action)
        case GroupsActionType.SET_SEARCH_TEXT:
            return setSearchText(state, action)

        case GroupsActionType.SET_CONFIRMATION_DIALOG:
            return SetCreateConfirmationDialog(state, action)
        default:
            return state
    }
}

const setEditGroup = (state, { data }) => {
    return {
        ...state,
        editGroupDialog: data,
    }
}

const setGroupsData = (state, { groups }) => {
    return {
        ...state,
        groups: groups.rows,
        total: groups.total,
    }
}

const closeEditDialog = (state) => {
    return {
        ...state,
        isEditDialogOpen: false,
        editGroupDialog: initialCreateState,
    }
}

const openEditDialog = (state) => {
    return {
        ...state,
        isEditDialogOpen: true,
    }
}

const closeCreateDialog = (state) => {
    return {
        ...state,
        isCreateDialogOpen: false,
        createGroupDialog: initialCreateState,
    }
}

const openCreateDialog = (state) => {
    return {
        ...state,
        isCreateDialogOpen: true,
    }
}

function setCreateGroupDialog(state, action) {
    return {
        ...state,
        createGroupDialog: action.createGroupDialog,
    }
}

function SetCreateConfirmationDialog(state, action) {
    return {
        ...state,
        isConfirmationDialogOpen: action.isOpen,
    }
}

function setSearchText(state, action) {
    return {
        ...state,
        table: {
            ...state.table,
            search: action.search,
        },
    }
}

function setFilter(state, action) {
    return {
        ...state,
        table: {
            ...state.table,
            filters: action.filters,
        },
    }
}

function setPageOffset(state, action) {
    return {
        ...state,
        table: {
            ...state.table,
            offset: action.offset,
        },
    }
}

function setPagingOptions(state, action) {
    return {
        ...state,
        table: {
            ...state.table,
            limit: action.paging.limit,
            offset: action.paging.offset,
        },
    }
}

function setOrderBy(state, action) {
    return {
        ...state,
        table: {
            ...state.table,
            orderBy: action.orderBy,
        },
    }
}

const setExistingPermissions = (state, { data }) => {
    return {
        ...state,
        existingPermissions: data.rows,
    }
}

const setExistingUsers = (state, { data }) => {
    return {
        ...state,
        existingUsers: data.rows,
    }
}
